module.exports = __webpack_public_path__ + "img/EDS.f3c27fe6.png";